import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import {
  TransportType,
} from '../api/models';
import {
  ApiNotificationConfig,
  ApiNotificationService,
} from './api-notification.service';
import { ConsoleService } from './console.service';

@Injectable({
  providedIn: 'root',
})
export class GatewayTransporterDescriptorService {
  constructor(
    private apiNotificationService: ApiNotificationService,
    private translateService: TranslateService
  ) {}

  checkDescriptor(descriptor: any){//ServiceResultOfGatewayTransporterDescriptor) {
    try {
      if (!descriptor.isSucceed) {
        let message: ApiNotificationConfig = {};
        message.result = {};
        message.result.detail = descriptor.error.message;
        message.result.succeeded = false;
        message.result.type = this.translateService.instant('common.payment');
        this.apiNotificationService.notifyMessage(message);
        return;
      }

      switch (descriptor.data.type) {
        case TransportType.Post:
          const form = document.createElement('form');
          form.setAttribute('method', 'post');
          // form.setAttribute('target', '_blank');
          form.setAttribute('action', descriptor.data.url);
          Object.keys(descriptor.data.form).forEach((key) => {
            const inputHidden = document.createElement('input');
            inputHidden.setAttribute('type', 'hidden');
            inputHidden.setAttribute('name', key);
            inputHidden.setAttribute('value', descriptor.data.form[key]);
            form.appendChild(inputHidden);
          });
          document.getElementsByTagName('body')[0].appendChild(form);
          form.submit();
          break;
        case TransportType.Redirect:
          window.location.href = descriptor.data.url;
          break;
        default:
          break;
      }
    } catch (error) {
      ConsoleService.error('', error);
    }
  }
}
